import {combineReducers} from 'redux';
import {getSuccessActionType} from '../utils';
import {getStatusReducer, getErrorReducer} from './utils/generators';
import {FETCH_CONSULT_PACKAGES} from '../constants/consult-package';

function data(state = [], action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_CONSULT_PACKAGES):
      return action.payload;

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_CONSULT_PACKAGES]),
  error: getErrorReducer([FETCH_CONSULT_PACKAGES]),
  data
});
